import {
  apiGetAllComments,
  apiGetAPostComments,
  apiGetReply,
} from "../api/comment";
import { CommentData, CommentReplyPropsData } from "../interface/comment";
import { MetaDataType } from "../interface/search";
import { AccountProfileDataStore } from "../store/contentSlice";

type CommentResponse = {
  data: CommentData[];
  meta: MetaDataType;
};
export const getComments = async (
  post_id: number
): Promise<CommentResponse> => {
  try {
    const response = await apiGetAPostComments(post_id);
    if (response.status === "error") {
      // Check if response is error response
      if ("details" in response) {
        console.warn("Error fetching comment:", response.details);
        return {
          data: [],
          meta: {
            current_page: 0,
            last_page: 0,
            page_size: 0,
            total: 0,
          },
        };
      }
      return {
        data: [],
        meta: {
          current_page: 0,
          last_page: 0,
          page_size: 0,
          total: 0,
        },
      };
    }
    if (response.status === 200) {
      return response.data as CommentResponse;
    }

    // If data structure doesn't match expected format, return empty array
    console.warn("Unexpected response structure:", response);
    return {
      data: [],
      meta: {
        current_page: 0,
        last_page: 0,
        page_size: 0,
        total: 0,
      },
    };
  } catch (error) {
    console.error("Error in comments:", error);
    return {
      data: [],
      meta: {
        current_page: 0,
        last_page: 0,
        page_size: 0,
        total: 0,
      },
    };
  }
};

export const newComment = (
  comment: string,
  profile_data: AccountProfileDataStore,
  post_id: string | string[]
) => {
  const newComment: CommentReplyPropsData = {
    id: Math.floor(Math.random() * 100),
    parent_id: null,
    post_id: Number(post_id),
    author_id: profile_data?.id,
    author_name: profile_data?.name,
    replies: [],
    author_photo_url: profile_data?.image,
    comment: comment,
    likes: 0,
    commented_at: new Date().toISOString(),
  };
  return newComment;
};

// similar for replies
export const newReply = (
  reply: string,
  profile_data: AccountProfileDataStore,
  post_id: number,
  reply_id: number
) => {
  const newReply = {
    id: Math.floor(Math.random() * 100),
    parent_id: reply_id,
    post_id: post_id,
    author_id: profile_data?.id,
    author_name: profile_data?.name,
    replies: [],
    author_photo_url: profile_data?.image,
    comment: reply,
    likes: 0,
    commented_at: new Date().toISOString(),
  };
  return newReply;
};

export const getReplies = async (value: {
  post_id: number;
  comment_id: number;
}): Promise<CommentData[]> => {
  try {
    const response = await apiGetReply(value);
    if (response.status === "error") {
      // Check if response is error response
      if ("details" in response) {
        console.warn("Error fetching Replies:", response.details);
        return [];
      }
      return [];
    }
    if (response.status === 200) {
      return response.data as CommentData[];
    }

    // If data structure doesn't match expected format, return empty array
    console.warn("Unexpected response structure:", response);
    return [];
  } catch (error) {
    console.error("Error in comments:", error);
    return [];
  }
};
